var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScheduled = function SvgScheduled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.416,
    height: 15.562,
    viewBox: "0 0 20.416 15.562",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.371,69.683V65.618A1.62,1.62,0,0,0,13.753,64H1.618A1.62,1.62,0,0,0,0,65.618v8.09a1.62,1.62,0,0,0,1.618,1.618h9.071a4.448,4.448,0,1,0,4.681-5.642ZM1.618,64.809H13.753c.017,0,.031.009.048.01L8.018,69.565a.683.683,0,0,1-.638.021L1.571,64.819C1.587,64.818,1.6,64.809,1.618,64.809Zm8.919,9.708H1.618a.81.81,0,0,1-.809-.809v-8.09A.8.8,0,0,1,.877,65.3L6.9,70.237a1.423,1.423,0,0,0,1.539.017.393.393,0,0,0,.065-.044L14.493,65.3a.8.8,0,0,1,.069.322v4.065a4.454,4.454,0,0,0-4.045,4.429C10.517,74.249,10.525,74.383,10.537,74.517Zm4.429,3.236a3.64,3.64,0,1,1,3.64-3.64A3.644,3.644,0,0,1,14.966,77.753Z",
    transform: "translate(0 -64)",
    fill: "#3953fb",
    stroke: "#3953fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.809,258.664V256.4a.4.4,0,1,0-.809,0v2.427a.4.4,0,0,0,.118.286l1.214,1.214a.4.4,0,0,0,.572-.572Z",
    transform: "translate(-369.438 -248.719)",
    fill: "#3953fb",
    stroke: "#3953fb",
    strokeWidth: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheduled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scheduled.f119972a.svg";
export { ForwardRef as ReactComponent };